import * as constant from '../constants/string';
import { ChangeRequestControllerService } from '../../services';

export const getValueAuthority = (label) => {
    const result = constant.AUTHORITY.filter((element) => label === element.label);
    return result[0].value;
};

export const getValueOrganization = (label) => {
    const result = constant.ORGANIZATION.filter((element) => label === element.label);
    return result[0].value;
};

export const addSelectedData = (apiResponse, setSelectData) => {
    if (apiResponse) {
        const displayData = apiResponse.data;
        setSelectData((prevState) => {
            const newData = [
                ...prevState.filter((item) => !displayData.some((newItem) => newItem.id === item.id)),
                ...displayData.filter((newItem) => newItem.selected),
            ];

            return newData;
        });
    }
};

export const editSelectedData = (apiResponse, setSelectData) => {
    if (apiResponse) {
        const displayData = apiResponse.data;
        setSelectData((prevState) => {
            const newDataMap = new Map(prevState.map((item) => [item.id, item])); // 既存データをMapに変換

            displayData.forEach((newItem) => {
                newDataMap.set(newItem.id, newItem); // 既存なら更新、新規なら追加
            });

            return Array.from(newDataMap.values()); // Mapを配列に戻す
        });
    }
};

export const addConfirmedData = (apiResponse, setSelectData) => {
    if (apiResponse) {
        const displayData = apiResponse.data;
        setSelectData((prevState) => {
            const newData = [
                ...prevState.filter((item) => !displayData.some((newItem) => newItem.id === item.id)),
                ...displayData.filter((newItem) => newItem.remand || newItem.confirmed),
            ];
            return newData;
        });
    }
};

export const updateSelectedData = (changeRequestType, ids, setSelectedData) => {
    ChangeRequestControllerService.getChangeRequestsByIds(changeRequestType, ids)
        .then((response) => {
            editSelectedData(response, setSelectedData);
        })
        .catch((error) => {});
};

export const checkEnableSelect = (isCompetitor, itemRowSelect, selectedRows, isMultiSelectRow) => {
    if (isCompetitor && checkPble(itemRowSelect.pbleFlag, itemRowSelect.exception)) {
        return false;
    }
    if (!selectedRows || selectedRows.length === 0 || isMultiSelectRow) {
        return true;
    }

    if (isCompetitor) {
        // 競合対抗は定価とユニット容量 または 定価とユニット単位 が同じ場合は複数選択可能
        // 定価とユニット容量 + 完全一致を許容
        const allCapacityOfUnit = selectedRows.every(
            (item) =>
                (item.listPrice === itemRowSelect.listPrice &&
                    item.capacityOfUnit === itemRowSelect.capacityOfUnit &&
                    item.unit !== itemRowSelect.unit) ||
                (item.listPrice === itemRowSelect.listPrice &&
                    item.capacityOfUnit === itemRowSelect.capacityOfUnit &&
                    item.unit === itemRowSelect.unit),
        );
        // 定価とユニット単位 + 完全一致を許容
        const allUnit = selectedRows.every(
            (item) =>
                (item.listPrice === itemRowSelect.listPrice &&
                    item.unit === itemRowSelect.unit &&
                    item.capacityOfUnit !== itemRowSelect.capacityOfUnit) ||
                (item.listPrice === itemRowSelect.listPrice &&
                    item.capacityOfUnit === itemRowSelect.capacityOfUnit &&
                    item.unit === itemRowSelect.unit),
        );
        // 完全一致のみ
        const allExact = selectedRows.every(
            (item) =>
                item.listPrice === itemRowSelect.listPrice &&
                item.capacityOfUnit === itemRowSelect.capacityOfUnit &&
                item.unit === itemRowSelect.unit,
        );

        return allCapacityOfUnit || allUnit || allExact;
    }
    const selectedRow = selectedRows[0];
    return itemRowSelect.jan === selectedRow.jan;
};

// 定価とユニット単位 + 完全一致を許容しない
export const isAllUnit = (selectedRows) => {
    return (
        selectedRows.every((item) => item.listPrice === selectedRows[0]?.listPrice && item.unit === selectedRows[0]?.unit) &&
        selectedRows.some((item) => item.capacityOfUnit !== selectedRows[0]?.capacityOfUnit)
    );
};

export const isIOS = () => {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

/**
 * 選択された商品が旧売変で登録された商品かどうかを判定する
 * （tokubaiProjectCode が 800000〜990000 の範囲）
 *
 * @param {{ tokubaiProjectCode: number }} item 判定対象の商品
 * @returns {boolean} 旧売変 true、新売変 false
 */
export const isLegacy = (item) => {
    return item.tokubaiProjectCode >= 800000 && item.tokubaiProjectCode <= 990000;
};

/**
 * 選択・登録可能なPB/留型商品か判定する
 *
 * @param {boolean} pbleFlag
 * @param {boolean} exception
 * @returns {boolean} true：登録可能
 */
export const checkPble = (pbleFlag, exception) => {
    return !exception && pbleFlag;
};
